import { gql } from '@apollo/client';
import { ENROLLMENT_SUBTRAINING_PROGRAM_FIELDS } from "./subtraining-program";
import { TRAINING_PERIOD_FIELDS } from "./training-period";
export const TRAINING_PROGRAM_TRAINING_PERIOD_FIELDS = gql`
  ${TRAINING_PERIOD_FIELDS}
  fragment TrainingProgramTrainingPeriodFields on TrainingProgramTrainingPeriodDto {
    id
    trainingPeriod {
      ...TrainingPeriodFields
    }
  }
`;
export const TRAINING_PROGRAM_FIELDS = gql`
  ${TRAINING_PROGRAM_TRAINING_PERIOD_FIELDS}
  fragment TrainingProgramFields on TrainingProgramDto {
    id
    name
    codeProgram
    codeOfficial
    trainingProgramTrainingPeriodList {
      ...TrainingProgramTrainingPeriodFields
    }
  }
`;
export const PROGRAM_RECORD_FIELDS = gql`
  ${TRAINING_PROGRAM_FIELDS}
  fragment ProgramRecordFields on ProgramRecordDto {
    id
    name
    businessUnitId
    businessUnitName
    creationTimestamp
    createdBy
    modifiedBy
    timestamp
    delegation {
      id
      name
      structure
    }
    trainingProgram {
      ...TrainingProgramFields
    }
  }
`;
export const ENROLLMENT_TRAINING_PROGRAM_FIELDS = gql`
  ${ENROLLMENT_SUBTRAINING_PROGRAM_FIELDS}
  fragment EnrollmentTrainingProgramFields on PortalEnrollmentTrainingProgramDTO {
    id
    name
    enrollmentSubtrainingPrograms {
      ...EnrollmentSubtrainingProgramFields
    }
  }
`;